import { i18n } from '@plugins/i18n'

export default function(msg) {
  let error = ''
  if (msg.length > 5) {
    error = 'CSVファイルに不正な値が多いので、ファイルを再度確認してください。'
    return error
  }
  msg.forEach((element) => {
    error += `${element.column}列${element.row + 1}行の「${
      element.data
    }」データ：${i18n.t(`device.${element.code}`)}\n`
  })
  return error
}
